export * from '@clevver/types/file'
export * from '@clevver/types/quota'
export * from '@clevver/types/user'
export * from '@clevver/types/tag'
export * from '@clevver/types/pagination'
export * from '@clevver/types/invoice'
export * from '@clevver/types/api-key'
export * from '@clevver/types/security-key'

export interface Purchase {
  id: number
  status: string
  progress: number
  created_at: number
}

export enum ViewMode {
  all = 'all',
  untagged = 'untagged',
  tagged = 'tagged',
}
